import React from 'react';
import { View, ScrollView,StyleSheet,Animated,TouchableOpacity,Image,Button,Dimensions,Modal , ImageBackground, ActivityIndicator} from 'react-native';
// import Icon from "react-native-vector-icons/dist/Ionicons";
// import { WebView } from 'react-native-webview';
import { Surface } from 'react-native-paper';
import { connect } from 'react-redux';
import {Text, Styles} from "./../../components/UI-Components";
// import AdsScreen from './../Ads';
// import Video from 'react-native-video';
import {  getExams, dispatchClearExams } from './../../store/actions';
import Header from "./../../components/Header/index.js";
import Container from '@material-ui/core/Container';
import LoadingComponent from "./../../components/LoaderComponent"
// const { width, height } = Dimensions.get("window");
const width = 480;
const _width = window.innerWidth;
 
const LibraryComponent = ({item, index, navigation}) => {
    const { imageUrl } = item; 
     return(
      <View  key={index} >
         
         <TouchableOpacity
            style={{}}
            onPress = {()=>{
             
                navigation.push('librarySubject', {
                   examId: item.id
               })
            }
            }
            activeOpacity={.9}
            key={index}
         >
              <View style={styles.main}>
                    <View
                    style={{
                        position: 'absolute',
                        top:0,
                        left:0,
                        right:0,
                        bottom:0,
                        backgroundColor: 'rgba(0,0,0,0.5)',
                        zIndex: 1
                    }}
                >
              <View style={{flex: 1, justifyContent: 'center', alignItems: 'flex-start', lineHeight: 1.2, paddingLeft: 6, paddingRight: 20, position: 'relative', zIndex: 200}}>
                    <Text style={{color: '#fff', fontSize: 20, fontWeight: 'bold'}}>
                        {item.exam_name}
                    </Text>
                </View>

          </View>
                  <View style={styles.imageContainer}>
                      <Image style={styles.imageIcon} 
                     source={{uri:item.imageUrl}}
                      resizeMode='cover'
                      />
                  </View>
              </View>
          </TouchableOpacity>
    
      </View>
     )
  }



class LibraryExamScreen extends React.Component{ 

    componentDidMount() {
       
        this.props.getExams(); 
    }
    // componentWillMount(){
    //     this.props.getExams();
    // }

    componentDidUpdate(prevProps) {       
        if (this.props.exams !== prevProps.exams) {
            if(this.props.exams) {
                const exams = this.props.exams.map((exam, index) => {
                    return {
                      exam_name: exam.exam_name,               
                      id: exam.id,
                      imageUrl: exam.icon_url
                    }
                  })
                // console.log(prevProps, this.props, 'component did update');
                this.setState({
                  books : exams
                })
            }  
        }

        if(this.props.err !== prevProps.err) {
            if(this.props.err) {
                // this.setState({showSnack: this.props.err});
                this.setState({snackbarMsg: 'something went wrong'});
          }
        }
      }
    
      componentWillUnmount() {
        this.props.dispatchClearExams();
      }

    constructor(props){
        super(props);
        this.state = {
            modalVisible: false,
            books:[]
        }
    }

    // static navigationOptions = ({navigation}) => {
    //     return {
    //         headerTitle: "COURSES" ,
    //         headerBackground: 
    //         ( <LinearGradientComponent />),
    //         headerTintColor:StylesColors.headerTintColor,
    //           headerTitleStyle: {
    //             color:StylesColors.headerTextColor,
    //             alignItems:'center',
    //             alignSelf: 'center',
    //             // width: '80%',
    //             textAlign: 'center',
    //             fontWeight:StylesColors.headerTextFontWeight
    //          },
    //     }
    // }

    fetchExams = () => {
        if(!(this.props.exams && this.props.exams.length)) {
            this.props.getExams();
        }
    }
 
    render() {
        
        return (
            <>
            <Header
            title="Library Exams"
            
            // headerRightClick={() => alert()}
            />
            <Container maxWidth='lg'>

            <div className='main-component'
            >
            
               <View >
      
           
                {
                    this.props.loading && <View style={{flex:1, justifyContent:'center', alignItems:'center'}}>
                        <LoadingComponent styles={{width: 250, height: 250}}/>
                        </View>
                }
                 {
                     this.props.err && <View style={{flex:1, justifyContent: 'center', alignContent:'center'}}> 
                        <Text>something went wrong... Please try again later</Text>
                     </View>
                 }

           <View style={{ flexDirection: 'column', flexWrap: 'wrap',marginTop:10, marginHorizontal: _width <= 479 ? 0 : 23}}>
           <ScrollView>
                     <View style={styles.examContainer}>
                        {
                           this.state.books && this.state.books.length > 0 && this.state.books.map((item, index) => {
                                return(
                                    <LibraryComponent
                                    index={index}
                                    item={item}
                                    navigation={this.props.history}
                                    />
                                )
                            })
                        }
                    
                    </View>   
            </ScrollView> 
           </View>
        {/* ================ads screen ====================== */}
      
          {/* <AdsScreen screenId={'Library'} /> */}
      
            </View>
        {/* ================ads screen end ====================== */}
         </div>
         </Container>
         </>
        )
    }
}
const styles = StyleSheet.create({
    mainImageView:{
        flex:1 ,
        marginTop:10,
        height: 150,
        width:_width <= 479  ? Math.floor(_width/3 + 10) : Math.floor(width/2 - 30),
        marginHorizontal: 12,
        // marginBottom,
        elevation: 8,
        cursor: 'pointer',
        // backgroundColor: '#f00',
    //    alignItems: 'center',
       
},
    ImageView:{
        flex:1, 
        // flex: 1,
        borderRadius:10,
        width: _width <= 479  ? Math.floor(_width/3 + 30) : Math.floor(width/2 - 18),
        // height:400
    },
    container: {
        flex: 1,
        borderWidth:1,
    },
    closeBtn:{
        fontWeight:'800',
        position:'absolute',
        top:50,
        right:15,
        zIndex:99999,
        fontSize:24,
        color:'#fff',
        alignItems:'center',
        },
        mainComponent: {
            flexDirection: 'column', 
            flexWrap: 'wrap',
            marginTop:10,
            flex: 1,
            marginHorizontal: 10,
            backgroundColor: Styles.fiveMantraBgColor,
            paddingTop: 19
          },
          examContainer: {
            flex: 1, 
            flexDirection: 'row', 
            flexWrap: 'wrap',
            // width: width,
            marginTop: 10
            
          },
          main:{
            marginTop:10,
            height: 150,
            width:_width <= 780  ? Math.floor(_width - 40) : Math.floor(width/2 - 30),
            // borderRadius:10,
            borderWidth: 4,
            borderColor: "#fff",
            marginHorizontal: 10,
            position:'relative',
            overflow:'hidden'
        },
        imageContainer:{
            flex: 1
        },
        imageIcon:{
            width: _width <= 780  ? '100%' : Math.floor(width/2 - 35),
            // borderRadius: 10,
            height:'100%'
        }
        
})

const mapStateToProps = state => ({
    loading: state.allExams && state.allExams.loading,
    exams: state.allExams && state.allExams.exams && state.allExams.exams.exams,
    err: state.allExams && state.allExams.examPreferencesError && state.allExams.examPreferencesError,
  })
  

export default connect(mapStateToProps, {  getExams, dispatchClearExams })(LibraryExamScreen); 